/**
 * Parse a date-only string ("YYYY-MM-DD", no time component) as a calendar
 * date in the browser's LOCAL timezone, not UTC midnight.
 *
 * `new Date("2026-05-08")` parses as UTC midnight. `toLocaleDateString()`
 * then renders that instant in the browser's local timezone, which shows
 * the PRIOR calendar day in every US timezone (all behind UTC) — e.g. a
 * stored "2026-05-08" displays as "May 7". Use this for any field that's a
 * pure calendar date (planned_delivery_date, sell_by, expiry/retest dates),
 * never for real timestamps (submitted_at, created_at, delivered_at) —
 * those already carry correct instant/timezone info and should keep using
 * `new Date(iso)` directly.
 */
export function parseDateOnly(dateStr: string): Date {
  const [year, month, day] = dateStr.split('-').map(Number)
  return new Date(year, month - 1, day)
}
